import * as prismic from '@prismicio/client';
import * as prismicNext from '@prismicio/next/pages';
import config from '../../slicemachine.config.json';

export const repositoryName = process.env.PRISMIC_ENV || config.repositoryName;

export const createClient = (
  configData: prismicNext.CreateClientConfig = {}
) => {
  const client = prismic.createClient(
    prismic.getRepositoryEndpoint(repositoryName),
    {
      accessToken: process.env.PRISMIC_API_TOKEN,
      ...configData,
    }
  );

  prismicNext.enableAutoPreviews({
    client,
    previewData: configData.previewData,
    req: configData.req,
  });

  return client;
};

export const defaultClient = createClient();
export default defaultClient;
